import React from 'react';

export default function EmptyState({ icon = 'bi-inbox', titulo, mensagem, acao }) {
  return (
    <div className="empty-state-cli">
      <i className={`bi ${icon}`} aria-hidden="true"></i>
      <h3>{titulo}</h3>
      {mensagem && <p>{mensagem}</p>}
      {acao && <div className="empty-state-acao-cli">{acao}</div>}
    </div>
  );
}
